import type { ReactNode } from 'react';
import type { Permission } from '@technohull/shared';
import { useAuth } from '../auth/AuthContext.js';
import { EmptyState, PageHeader } from '../components/ui.js';

/** Client-side route guard (defence-in-depth; the API also enforces server-side). */
export function RequirePermission({ perm, anyPerm, children }: { perm?: Permission; /** any one of these will do */ anyPerm?: Permission[]; children: ReactNode }) {
  const { can } = useAuth();
  if ((perm && !can(perm)) || (anyPerm && !anyPerm.some((p) => can(p)))) {
    return (
      <div className="state error" style={{ paddingTop: 64 }}>
        <div className="big">Access denied</div>
        <div className="muted">You don't have permission to view this page.</div>
      </div>
    );
  }
  return <>{children}</>;
}

export function Placeholder({ title }: { title: string }) {
  return (
    <>
      <PageHeader title={title} />
      <div className="page-panel">
        <EmptyState title="No page here" hint="This address doesn't match any page. Use the menu to open the one you need." />
      </div>
    </>
  );
}
